import { Button, Flex, Text } from "@chakra-ui/react";
import Illustration from "./illustration";
import { Link } from "react-router-dom";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";
import gsap from 'gsap'
import { useTranslation } from "../../i18n/LanguageContext";
import { trackUmamiEvent } from "../../lib/analytics/umami";
import { handleAuthRedirectClick } from "../../lib/navigation/externalBrowser";

export default function Baseline() {

  const container = useRef();
  const { t } = useTranslation();

  useGSAP(
    () => {
      gsap.from(".slide-in-1, .slide-in-2, .slide-in-3", {
        x: -200,
        opacity: '0',
        duration: 0.5,
        ease: "power2.inOut",
        stagger: 0.1
      });
    },
    { scope: container }
  );

  return (
    <Flex
      as="section"
      aria-label={t("hero.aria")}
      backgroundColor={"#F6F6F6"}
      padding={["16px", "24px", "0 0 0 64px"]}
      borderRadius={["32px", "32px", "32px"]}
      minH={["auto", "auto", "832px"]}
      gap={["20px", "24px", "20px"]}
      width={"100%"}
      maxW={"1280px"}
      alignItems={["flex-start", "flex-start", "center"]}
      justifyContent={"space-between"}
      ref={container}
      flexDirection={["column", "column", "row"]}
      overflow={"hidden"}
    >
      <Flex
        flexDirection={"column"}
        flexShrink={"0"}
        maxW={["100%", "100%", "633px"]}
        gap={"20px"}
      >
        <Flex className="slide-in-1" flexDirection={"column"} gap={"10px"}>
          <Text
            as="h1"
            color={"text.dark.grey"}
            maxW={["100%", "100%", "633px"]}
            fontSize={["40px", "48px", "60px"]}
            fontWeight={"600"}
            lineHeight={"1.25"}
            letterSpacing={"-0.02em"}
          >
            {t("hero.title")}
          </Text>
          <Text
            as="p"
            color={"text.medium.grey"}
            maxW={["100%", "100%", "540px"]}
            fontSize={["20px", "22px", "27px"]}
            lineHeight={"1.25"}
            className="slide-in-2"
          >
            {t("hero.subtitle")}
          </Text>
        </Flex>
        <Link
          to={process.env.REACT_APP_BIBLIONA_URL}
          className="slide-in-3"
          target='_blank'
          aria-label={t("hero.signInAria")}
          onClick={(event) =>
            handleAuthRedirectClick(event, process.env.REACT_APP_BIBLIONA_URL, () =>
              trackUmamiEvent("cta_click", { location: "hero", cta: "sign_in" })
            )
          }
        >
          <Button
            variant={"coralFill"}
            width={"241px"}
            h={"40px"}
            fontSize={"16px"}
            fontWeight={"600"}
          >{t("hero.signIn")}</Button>
        </Link>
      </Flex>
      <Flex display={["none", "none", "flex"]} flex={"1"} minW={"0"} h={"832px"}>
        <Illustration />
      </Flex>
    </Flex>
  );
}
